<template>
  <div class="c-select-address">
    <el-select
      v-model="region.province"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :size="size"
      value-key="value"
      placeholder="请选择省份"
      @change="handleChangeProvince"
    >
      <el-option
        v-for="item in regionOption.province"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-select
      v-model="region.city"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :size="size"
      value-key="value"
      placeholder="请选择城市"
      @change="handleChangeCitys"
    >
      <el-option
        v-for="item in regionOption.city"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-select
      v-model="region.county"
      :filterable="filterable"
      :clearable="clearable"
      :disabled="disabled"
      :size="size"
      value-key="value"
      placeholder="请选择区/县"
      @change="handleChangeCountys"
    >
      <el-option
        v-for="item in regionOption.county"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectAddress',
  props: {
    apiPath: {
      type: String,
      default: ''
    },
    // 输入框尺寸
    size: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    // 地址类型 default默认 cascader级联选择器
    type: {
      type: String,
      default: 'default'
    },
    // 默认数据
    value: {
      type: String,
      default: null
    },
    // 是否可搜索
    filterable: {
      type: Boolean,
      default: true
    },
    // 是否可清空选项
    clearable: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择地址'
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      addressApiPath: `${this.$config.ctx.iffApi}/common/address`,
      region: {
        province: null,
        city: null,
        county: null
      },
      regionOption: {
        province: [], // 省份
        city: [], // 市
        county: [] // 县
      }
    };
  },
  methods: {
    /**
     * @description: 切换省份，重新获取城市数据
     * @param {*} val
     * @return {*}
     */
    handleChangeProvince (val) {
      this.region.city = null;
      this.region.county = null;
      this.regionOption.city = [];
      this.regionOption.county = [];
      if (val) {
        this.handleQueryRegion('city', val);
      }

      if (!this.required) {
        const address = this.handleObjectValues(this.region).join('/');
        this.$emit('input', address);
      } else {
        this.$emit('input', null);
      }
    },
    /**
     * @description: 切换城市，重新获取县级数据
     * @param {*} val
     * @return {*}
     */
    handleChangeCitys (val) {
      this.region.county = null;
      this.regionOption.county = [];
      if (val) {
        this.handleQueryRegion('county', val);
      }
      if (!this.required) {
        const address = this.handleObjectValues(this.region).join('/');
        this.$emit('input', address);
      }
    },
    /**
     * @description: 切换县
     * @param {*} val
     * @return {*}
     */
    handleChangeCountys (val) {
      const address = this.handleObjectValues(this.region).join('/');
      this.$emit('input', address);
    },
    handleObjectValues (_object) {
      const props = Object.keys(Object(_object));
      const _values = props.map((key) => _object[key]);
      return _values;
    },
    /**
     * @description: 获取区域数据
     * @param {*} type province、city、county：省、市、区
     * @param {*} code 地区编码
     * @return {*}
     */
    handleQueryRegion (type, code) {
      return this.$axios.get(this.addressApiPath, { params: { code: code } })
        .then(rsp => {
          this.regionOption[type] = rsp.data;
        })
        .catch(err => {
          console.error(type + '加载失败！', err);
        });
    },
    // 解析默认地址
    handleAnalysisDefaultAddress () {
      if (!this.value) return;
      let address = '';
      try {
        address = this.value.split('/') || [];
      } catch (error) {
        console.log('地址信息不合规范:' + error);
      }
      const dataFormat = address instanceof Array;
      if (!dataFormat) return;
      [
        this.region.province,
        this.region.city,
        this.region.county
      ] = address;

      if (this.region.province) {
        this.handleQueryRegion('city', this.region.province);
      }

      if (this.region.city) {
        this.handleQueryRegion('county', this.region.city);
      }
    },
    getAddressMc () {
      const _this = this;
      const addressMc = [];
      for (const _key in this.region) {
        const regionMc = _this.regionOption[_key].filter(item => item.value === this.region[_key]);
        if (regionMc.length > 0) {
          // eslint-disable-next-line no-const-assign
          addressMc.push(regionMc[0].label);
        } else {
          // eslint-disable-next-line no-const-assign
          addressMc.push('');
        }
      }
      return addressMc;
    }
  },
  watch: {
    value: {
      handler (newValue) {
        if (newValue && !this.region.province) {
          this.handleAnalysisDefaultAddress();
        }
      },
      deep: true
    }
  },
  async created () {
    await this.handleQueryRegion('province');
    this.handleAnalysisDefaultAddress();
  }
};
</script>

<style lang="scss">
.c-select-address {
  display: flex;
  justify-content: space-between;

  .el-select {
    flex: 0.33;

    & + .el-select {
      margin-left: 4px;
    }
  }
}
</style>
